module.exports = __webpack_public_path__ + "img/21_13.6e7e2fe3.png";